import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment.prod';
import { AppConstants } from '../../../constants/app.constants';
import { PostMediaModel, PostModel } from '../../../models/post.model';

@Injectable({
  providedIn: 'root'
})
export class AddUpdatePostService {

  controller: string = 'Post/';
  baseUrl: string = AppConstants.accessBaseUrl;
  API_KEY = environment.secreteKey;
  private readonly headers = new HttpHeaders({ 'x-api-key': this.API_KEY, 'Content-Type': 'application/json' });
  options = { headers: this.headers };

  constructor(private readonly http: HttpClient) { }

  uploadPostMedia(formData: FormData): Observable<PostMediaModel> {
    return this.http.post<PostMediaModel>(this.baseUrl + this.controller + AppConstants.uploadPostMedia, formData);
  }

  createPost(post: PostModel): Observable<PostModel> {
    return this.http.post<PostModel>(this.baseUrl + this.controller + AppConstants.createPost, post, this.options);
  }

  updatePost(post: PostModel): Observable<PostModel> {
    return this.http.post<PostModel>(this.baseUrl + this.controller + AppConstants.updatePost, post, this.options);
  }

  deletePostMedia(formData: FormData) {
    return this.http.post(this.baseUrl + this.controller + AppConstants.deletePostMedia, formData);
  }

  getPostDetailsByPostUid(postUid: string): Observable<PostModel> {
    const params = new HttpParams().set('postUid', postUid);
    return this.http.get<PostModel>(this.baseUrl + this.controller + AppConstants.getPostDetailsByPostUid, { ...this.options, params });
  }

  getPostPdf(pdfPath: string): Observable<Blob> {
    let params = new HttpParams().set('postPdfPath', pdfPath)
    return this.http.get<Blob>(this.baseUrl + this.controller + AppConstants.getPostPdf, { ...this.options, params, responseType: 'blob' as 'json' });
  }
}
